import ApiService, {ApiPost} from '../../../shared/services/api-service';
import commonActionCreators from '../../../shared/store/common/action-creators';
import formCommitTypes from './commit-types';
import notificationsActionsCreator from '../notifications/action-creators';

const formsActions = {
  activateForm(formGuid) {
    return async (dispatch) => {
      dispatch(this.setIsLoading('activateForm'));
      const data = await ApiService.post(`/api/v1/forms/${formGuid}/activate`)
        .then(response => response.data)
        .catch((error) => {
          Promise.resolve();
          dispatch(commonActionCreators.handleApiError(error));
        });
      dispatch(this.setIsLoading('activateForm'));
      if (data) {
        dispatch(this.activateFormSuccess(data));
      }
      return Promise.resolve(data.data.guid);
    };
  },
  activateFormSuccess(activatedFormResponse) {
    return async (dispatch) => {
      dispatch(this.replaceForms(activatedFormResponse.data));
      dispatch(notificationsActionsCreator.addSavedSuccessfully('Form activated'))
    };
  },
  closeEditForm() {
    return {
      isEditingForm: false,
      type: formCommitTypes.SET_IS_EDITING_FORM,
    };
  },
  fetchForms() {
    return async (dispatch) => {
      dispatch(this.setIsLoading('fetchForms'));
      const data = await ApiService.get('/api/v1/forms')
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.resolve();
        });
      dispatch(this.setIsLoading('fetchForms'));
      if (data) {
        dispatch(this.fetchFormsSuccess(data));
      }
      return Promise.resolve();
    };
  },
  fetchFormsSuccess(formsResponse) {
    return {
      list: formsResponse.data,
      type: formCommitTypes.PUSH_FORMS,
    };
  },
  pushForm(form) {
    return {
      form,
      type: formCommitTypes.PUSH_FORM,
    };
  },
  resetFormsState() {
    return {
      type: formCommitTypes.RESET_FORMS_STATE,
    };
  },
  replaceForm(form) {
    return {
      form,
      type: formCommitTypes.REPLACE_FORM,
    };
  },
  replaceForms(list) {
    return {
      list,
      type: formCommitTypes.REPLACE_FORMS,
    };
  },
  reviseForm(formGuid) {
    return async (dispatch) => {
      dispatch(this.setIsLoading('reviseForm'));
      const data = await ApiService.post(`/api/v1/forms/${formGuid}/draft`)
        .then(response => response.data)
        .catch((error) => {
          Promise.resolve();
          dispatch(commonActionCreators.handleApiError(error));
        });
      dispatch(this.setIsLoading('reviseForm'));
      if (data) {
        dispatch(this.reviseFormSuccess(data));
      }
      return Promise.resolve(data.data.guid);
    };
  },
  reviseFormSuccess(revisedFormResponse) {
    return async (dispatch) => {
      dispatch(this.pushForm(revisedFormResponse.data));
      dispatch(notificationsActionsCreator.addSavedSuccessfully('Form revised'))
    };
  },
  setIsLoading(isLoading) {
    return {
      isLoading,
      type: formCommitTypes.SET_FORMS_IS_LOADING,
    };
  },
  setSelectedForm(selectedGuid) {
    return {
      selectedGuid,
      type: formCommitTypes.SET_SELECTED_FORM,
    };
  },
  updateForm(formGuid, formData) {
    console.log('FORM', formData)
    let form = {
      name: formData.name,
      layout: formData.layout
    }
    if (formData.scale || formData.riskAlert) {
      form.settings = {
        scale: formData.scale ? parseInt(formData.scale) : null,
        riskAlert: formData.riskAlert ?
          (formData.riskAlert === 'disabled' ? 'disabled' : parseInt(formData.riskAlert)) : null,
      }
    }

    if(formData.requireAckComment !== undefined) {
      form.settings = {
        ...(form.settings || {}),
        requireAckComment: formData.requireAckComment
      }
    }


    return async (dispatch) => {
      dispatch(this.setIsLoading('updateForm'));
      const data = await ApiService.patch(`/api/v1/forms/${formGuid}`, form)
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.resolve();
        });
      dispatch(this.setIsLoading('updateForm'));
      if (data) {
        dispatch(this.updateFormSuccess(data));
      }
      return Promise.resolve();
    };
  },

  createForm(form) {
    return (dispatch) => {
      return ApiPost('/api/v1/forms/draft', form)
        .then(form => {
          dispatch({
            form,
            type: formCommitTypes.PUSH_FORM
          });

          return form
        })
    }

  },

  updateFormSuccess(updated) {
    return (dispatch) => {
      dispatch(this.replaceForm(updated.data));
      dispatch(this.closeEditForm());
      dispatch(notificationsActionsCreator.addSavedSuccessfully('Form updated'))
    };
  },
};

export default formsActions;
